import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CityDropdown from "./CityDropdown";
import DeveloperDropdown from "./developerdropdown";
import ProjectDropdown from "./projectdropdown";
import "./PropertySearch.css";

const PRICE_OPTIONS = [
  300000, 500000, 800000, 1000000, 1500000,
  2000000, 3000000, 5000000, 8000000, 10000000,
];

const NewPropertySearchControl = ({ defaultValues }) => {
  const navigate = useNavigate();

  const [city, setCity] = useState(null);
  const [developer, setDeveloper] = useState(null);
  const [project, setProject] = useState(null);
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const [showPricePopup, setShowPricePopup] = useState(false);

  const priceRef = useRef(null);

  useEffect(() => {
    setCity(
      defaultValues?.city
        ? {
            value: defaultValues.city,
            label: defaultValues.city,
          }
        : null
    );

    setDeveloper(
      defaultValues?.developer
        ? {
            value: defaultValues.developer,
            label: defaultValues.developer_name || defaultValues.developer,
          }
        : null
    );

    setProject(
      defaultValues?.project
        ? {
            value: defaultValues.project,
            label: defaultValues.project_name || defaultValues.project,
          }
        : null
    );

    setMinPrice(defaultValues?.minPrice || "");
    setMaxPrice(defaultValues?.maxPrice || "");
  }, [defaultValues]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        priceRef.current &&
        !priceRef.current.contains(e.target)
      ) {
        setShowPricePopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearchClick = () => {
    const payload = {
      offering_type: "Latest Launches",
      city: city?.value || "",
      developer: developer?.value || "",
      developer_name: developer?.label || "",
      project: project?.value || "",
      project_name: project?.label || "",
      property_category: "",
      property_type: "",
      bedrooms: "",
      bathrooms: "",
      minArea: "",
      maxArea: "",
      minPrice,
      maxPrice,
    };

    const queryStr = new URLSearchParams(payload).toString();
    navigate(`/new-projects?${queryStr}`);
  };

  return (
    <div className="search-container">
      <div className="search-top latest-launches-search-row">
        <div className="location-box">
          <CityDropdown value={city} onChange={setCity} />
        </div>

        <DeveloperDropdown value={developer} onChange={setDeveloper} />
        <ProjectDropdown value={project} onChange={setProject} />

         

        <button className="search-main-btn" onClick={handleSearchClick}>
          Search
        </button>
      </div>
    </div>
  );
};

export default NewPropertySearchControl;
